export class ShipmentTrackingResponse {
  shipmentId?: number;
  accepted?: boolean;
  infoMessages?: string[];

  constructor(opts?: Partial<ShipmentTrackingResponse>) {
    if (opts?.shipmentId != null) {
      this.shipmentId = opts.shipmentId;
    }
    if (opts?.accepted != null) {
      this.accepted = opts.accepted;
    }
    if (opts?.infoMessages != null) {
      this.infoMessages = opts.infoMessages;
    }
  }
}
